module.exports = __webpack_public_path__ + "static/media/Cabs2.0-250-125-A.810fc989.png";